const either = require('ramda').either
const isEmpty = require('ramda').isEmpty
const isNil = require('ramda').isNil

module.exports = either(isNil, isEmpty)
